// App version - increment this to verify deployments
export const APP_VERSION = '0.0.1';

